var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LINKS_LIST } from '../../constants/menu';
import Link from '../../components/Link';
import SubMenu, { SUB_MENU_ID } from '../../parts/NavBar/SubMenu';
import isDescendant from '../../../shared/utils/isDescendant';
import styles from '../../parts/NavBar/index.module.scss';
import { ANIM_SPEED_SHORT } from '../../constants/anim';
const MENU_ID = 'nav_bar_link_wrap';
const NavBar = ({ withoutMyAccount }) => {
    const [activeMenuMoveLink, setActiveMenuMoveLink] = useState(null);
    const [isSubMenuAppear, setSubMenuAppear] = useState(false);
    const _handleMouseMove = ({ target, type }, isOutside) => {
        const parent = LINKS_LIST.find((link) => !!link.subMenu && link.subMenu.find((item) => item.navigateTo === target.dataset.navigateTo));
        if ((type === 'focus' && !parent) || isOutside) {
            setActiveMenuMoveLink(null);
            setSubMenuAppear(false);
            return;
        }
        if (isDescendant(target, MENU_ID, 'type')) {
            const isMenuElem = () => LINKS_LIST.some(({ navigateTo }) => navigateTo === target.dataset.navigateTo);
            if (!isDescendant(target, SUB_MENU_ID, 'type') && isMenuElem()) {
                setActiveMenuMoveLink(target.dataset.navigateTo);
            }
            else if (isDescendant(target, SUB_MENU_ID, 'type')) {
                setActiveMenuMoveLink(parent.navigateTo);
            }
            setSubMenuAppear(true);
        }
    };
    const _renderMenu = (_a, index) => {
        var { id, navigateTo, isSPA, subMenu } = _a, link = __rest(_a, ["id", "navigateTo", "isSPA", "subMenu"]);
        if (withoutMyAccount && index === LINKS_LIST.length - 1) {
            return null;
        }
        const isActiveMoveLink = activeMenuMoveLink === navigateTo;
        const isDesktopSubMenu = isActiveMoveLink && isSubMenuAppear;
        const _renderSubMenu = () => React.createElement(SubMenu, { subMenu: subMenu });
        const _renderSubMenuWitDesktopAnimation = () => {
            return (React.createElement(CSSTransition, { in: isDesktopSubMenu, classNames: 'navbar-desktop', timeout: ANIM_SPEED_SHORT }, _renderSubMenu()));
        };
        return (React.createElement("li", { key: id, "data-type": MENU_ID, "data-id": navigateTo, "data-sub-menu": !!subMenu, className: styles.navBarLinkWrap, onMouseEnter: (e) => _handleMouseMove(e, false), onMouseLeave: (e) => _handleMouseMove(e, true), onFocus: (e) => _handleMouseMove(e, false), onBlur: (e) => _handleMouseMove(e, false) },
            React.createElement(Link, Object.assign({}, link, { label: link.label, id: id, navigateTo: navigateTo, isSPA: isSPA, type: 'menu', withArrow: false, isFullWidth: false, 
                // noUnderscore={!!subMenu}
                isOpen: isDesktopSubMenu, isActive: isActiveMoveLink, arrowSize: 'S', preventNavigation: !!subMenu, withoutFill: true })),
            _renderSubMenuWitDesktopAnimation()));
    };
    return (React.createElement("nav", null,
        React.createElement("ul", { className: styles.menuWrap }, LINKS_LIST.map(_renderMenu))));
};
export default NavBar;
